import React, { FunctionComponent } from 'react'
import Modal from '../../../../../../shared/components/Modal'
import iconeFalha from 'shared/assets/icons/icon-falha.svg'
import { Container, ContainerContent } from './styles'
import {
  Subtitle,
  Title,
} from '../../../components/ListExtrato/components/ExtratoItem/ModalSolicitacaoExtrato/styles'
import { Grid } from '@material-ui/core'
import Button from '../../../../../../shared/components/Button'
import { usePagamentoBoleto } from '../../../../hooks/usePagamentoBoleto'

interface ModalErroProp {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  mensagemErro?: string
}
const ModalErro: FunctionComponent<ModalErroProp> = ({
  openModal,
  mensagemErro,
  setOpenModal,
}) => {
  const { limpar } = usePagamentoBoleto()
  return (
    <>
      <Modal
        openModal={openModal}
        showCloseButton
        curvature
        onCloseModal={() => setOpenModal(false)}
      >
        <Container>
          <ContainerContent>
            <Grid
              container
              spacing={0}
              justifyContent={'center'}
              alignContent={'center'}
              alignItems={'center'}
            >
              <Grid item xs={12}>
                <img src={iconeFalha} alt="Erro" />
              </Grid>
              <Grid item xs={12}>
                <Title>Não foi possível realizar o pagamento</Title>
              </Grid>
              <Grid
                item
                xs={12}
                justifyContent={'center'}
                alignContent={'center'}
                alignItems={'center'}
                style={{
                  textAlign: 'center',
                  marginTop: 8,
                }}
              >
                <Subtitle>
                  {mensagemErro ??
                    'Este boleto não está disponível ou já foi pago anteriormente'}
                </Subtitle>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: 40,
                }}
              >
                <Button
                  style={{
                    backgroundColor: '#24A95D',
                    width: '100%',
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                  onClick={() => {
                    setOpenModal(false)
                    limpar()
                  }}
                >
                  Entendi
                </Button>
              </Grid>
            </Grid>
          </ContainerContent>
        </Container>
      </Modal>
    </>
  )
}

export default ModalErro
